import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { ForEmployersPage } from './pages/ForEmployersPage';
import { ContactPage } from './pages/ContactPage';
import { BlogPage } from './pages/BlogPage';
// ScrollToTop component to handle scroll restoration
import { useLocation } from 'react-router-dom';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer to ensure the target element is mounted
      const id = hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        } else {
          window.scrollTo(0, 0);
        }
      }, 50);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="flex flex-col min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/services" element={<ServicesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/how-it-works" element={<HowItWorksPage data-id="element-13" />} data-id="element-12" />
            <Route path="/testimonials" element={<TestimonialsPage data-id="element-15" />} data-id="element-14" />
            <Route path="/employers" element={<ForEmployersPage data-id="element-17" />} data-id="element-16" />
            <Route path="/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
            <Route path="/blog" element={<BlogPage data-id="element-21" />} data-id="element-20" />
          </Routes>
        </main>
        <Footer data-id="element-22" />
      </div>
    </Router>;
}